'use client';
import { FacebookProvider, CustomChat } from 'react-facebook';

const Messenger = () => {
  <FacebookProvider appId="645354484895312" chatSupport>
    <CustomChat pageId="104919105543864" minimized={true} />
    <p>FB</p>
  </FacebookProvider>;
};

export default Messenger;
